<template>
    <div>
        <!-- Footer Section start -->
        <div class="copyright-section index-footer bg-light">
            <p>2021 copyright by Xtreme Controls Ltd, all rights reserved</p>
        </div>
        <!-- Footer Section End -->
        <!-- Tap on Top -->
        <div class="tap-top">
            <div>
                <i class="fa fa-angle-double-up"></i>
            </div>
        </div>
    <!-- Tap on Ends -->
    </div>
</template>
<script>
export default {
    name: "Footer"
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/footer.vue